import { GameInfoFragment } from '@apeiron/temp'
import { gql } from '@apollo/client'

export default gql`
  query VerifyAccount {
    getAccountDetail {
      accountGameInfo {
        ...GameInfo
      }
    }
  }

  ${GameInfoFragment}
`
